import React from 'react';

import './new-badge.scss';


const NewBadge = () => (
    <span className="new-badge">NEW</span>
);

export default NewBadge;